import { render, staticRenderFns } from "./ModalNotification.vue?vue&type=template&id=16f42c10&scoped=true"
import script from "./ModalNotification.vue?vue&type=script&lang=ts"
export * from "./ModalNotification.vue?vue&type=script&lang=ts"
import style0 from "./ModalNotification.vue?vue&type=style&index=0&id=16f42c10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f42c10",
  null
  
)

export default component.exports